import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { referralApi } from '../api/referral.api';
import { referralKeys } from '../api/referral.keys';

export function useReferralList(params: any) {
  return useQuery({
    queryKey: referralKeys.list(params),
    queryFn: () => referralApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useReferralDetails(id: any) {
  return useQuery({
    queryKey: referralKeys.detail(id),
    queryFn: () => referralApi.getById(id),
    enabled: !!id,
  });
}
